import { Alert, Button } from "antd";
import { API_PIN_RESET, API_PIN_RESET_REQUEST } from "../../utils/apis";
import { useEffect, useState } from "react";

import useSet from "../../hooks/common/useSet";
import { useToasts } from "../../hooks/common/useToasts";

export const useReSetWalletPinForm = ({ form }) => {
  const pinsMatch = form?.pin === form?.confirm_pin;
  const [pinValid, setPinValid] = useState(false);

  const visible =
    form?.pin != "" &&
    form?.pin != null &&
    form?.confirm_pin != null &&
    form?.confirm_pin != "";

  const pinValidate = (pin: string) => {
    return pin.length === 4 && /^\d{4}$/.test(pin);
  };

  useEffect(() => {
    if (form?.pin) {
      const isValid = pinValidate(form?.pin);
      if (!isValid) {
        setPinValid(true);
      } else {
        setPinValid(false);
      }
    }
  }, [form?.pin]);

  const { uploadData, success, error } = useSet();

  // Integrate useToasts for success message
  useToasts({
    success,
    error,
    successMessage: "Reset code sent to your email",
  });

  // Function to handle form submission for reset code request
  const submitForm = (e) => {
    e.preventDefault();
    uploadData({
      api: API_PIN_RESET_REQUEST,
      params: form,
    });
  };

  // Removed automatic API call on component mount to prevent submission on refresh
  // The submitForm function is now only triggered by button click

  const fields: any = [
    {
      type: "component",
      component: (
        <p className="font13">
          Enter your new PIN here. It should be exactly <b>4 digits</b>.
        </p>
      ),
    },
    {
      type: "component",
      component: (
        <Button type="primary" onClick={submitForm} style={{ marginTop: 16 }}>
          Send Reset Code
        </Button>
      ),
      props: { newLine: true },
    },
    {
      field_name: "reset_code",
      type: "otp-pin-input",
      label: "Reset Code",
      props: { required: true, newLine: true, length: 6, bgVariant: "white" },
    },
    {
      field_name: "pin",
      type: "otp-pin-input",
      label: "New PIN",
      props: {
        required: true,
        newLine: true,
        type: "password",
        length: 4,
        bgVariant: "white",
      },
    },
    {
      type: "component",
      visible: pinValid,
      component: (
        <Alert showIcon message={"PIN must be exactly 4 digits"} type="error" />
      ),
      props: { newLine: true },
    },
    {
      field_name: "confirm_pin",
      type: "otp-pin-input",
      label: "Confirm PIN",
      props: {
        required: true,
        newLine: true,
        type: "password",
        length: 4,
        bgVariant: "white",
      },
    },
    {
      type: "component",
      visible,
      component: (
        <Alert
          showIcon
          message={pinsMatch ? "PINs Match" : "PINs do not match"}
          type={pinsMatch ? "success" : "error"}
        />
      ),
      props: { newLine: true },
    },
  ];
  const sections = [
    {
      title: "Change Wallet PIN",
      fields,
    },
  ];

  function onSubmit(payload: any) {
    return {
      api: API_PIN_RESET,
      params: {
        ...payload,
        // reset_code: resetToken,
      },
      method: "POST",
    };
  }

  return {
    sections,
    submitDisabled: !pinsMatch || pinValid,
    onSubmit,
  };
};
